import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// CSRF: read the sw_csrf cookie and echo it as X-CSRF-Token on unsafe methods.
function readCookie(name) {
  const m = document.cookie.match(new RegExp("(^|;\\s*)" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[2]) : null;
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const SAFE_METHODS = new Set(["get", "head", "options"]);

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (!SAFE_METHODS.has(method)) {
    const csrf = readCookie("sw_csrf");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});
